import React from 'react';
import './TechStack.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const techStack = [
    { name: 'Flutter', icon: 'iconsite/flutter-svgrepo-com.svg' },
    { name: 'Dart', icon: 'iconsite/dart-svgrepo-com.svg' },
    { name: 'React', icon: 'iconsite/react-javascript-js-framework-facebook-svgrepo-com.svg' },
    { name: 'TypeScript', icon: 'iconsite/typescript-official-svgrepo-com.svg' },
    { name: 'Python', icon: 'iconsite/python-svgrepo-com.svg' },
    { name: 'PHP', icon: 'iconsite/php-svgrepo-com.svg' },
    { name: 'MySQL', icon: 'iconsite/mysql-svgrepo-com.svg' },
    { name: 'Docker', icon: 'iconsite/docker-svgrepo-com.svg' },
    { name: 'Linux', icon: 'iconsite/linux-svgrepo-com.svg' },
    { name: 'Nginx', icon: 'iconsite/nginx-svgrepo-com.svg' },
    { name: 'Node.js', icon: 'iconsite/node-js-svgrepo-com.svg' }
];

function TechCard({ tech }) {
    const cardRef = useScrollAnimation();

    return (
        <div className="tech-card" ref={cardRef}>
            <img src={tech.icon} alt={tech.name} />
            <span>{tech.name}</span>
        </div>
    );
}

function TechStack() {
    return (
        <section className="tech-section" id="tech">
            <div className="section-inner">
                <span className="section-label">Стек технологий</span>
                <h2 className="section-title">Инструменты,<br />которым мы доверяем</h2>
                <p className="section-sub" style={{marginBottom: '3rem'}}>
                    Используем проверенные технологии для решения различных задач — от пользовательского интерфейса до серверной инфраструктуры.
                </p>

                <div className="tech-grid">
                    {techStack.map((tech, index) => (
                        <TechCard tech={tech} key={index} />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TechStack;